// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__Z-0bm","active":"Pagination_active__UoG83"};